import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { SEARCH_PANEL_MOBILE_CLASSES } from "./constants";

export const SearchPanelMobileContainer = styled(Drawer)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  return {
    "&.MuiDrawer-root": {
      [formatMedia.BREAKPOINT_DESKTOP]: {
        display: "none",
      },
    },
    [`& .${SEARCH_PANEL_MOBILE_CLASSES.drawer}`]: {
      width: "100%",
      height: "100%",
    },
    [`& .${SEARCH_PANEL_MOBILE_CLASSES.toolbar} > * :not(:last-of-type)`]: {
      marginRight: theme.spacing(0.5),
    },
  };
});
